export default __webpack_public_path__ + "static/logo-8743cf5398db9bd9b63123f55ec80b3b.svg";